import propTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';
import { useModal } from '../modal';

BgColor.propTypes = {
  initialBgColor: propTypes.string,
  save: propTypes.func,
};

export const bgColorById = {
  all_wp_01: '#FFFFFFFF',
  all_wp_02: '#DBDFE7FF',
  all_wp_03: '#C5C9D3FF',
  all_wp_04: '#B2B7C2FF',
};

export default function BgColor({ initialBgColor, save }) {
  const { t } = useTranslation();
  const { popModal } = useModal();
  const [selectedColor, setSelectedColor] = useState(initialBgColor);

  const handleClickClose = () => {
    popModal();
  };

  const handleSave = async () => {
    if (selectedColor) {
      CommonService.setOptionValue(
        UserOptionName.DefaultChannelBgColor,
        selectedColor,
      );
      await save(selectedColor);
    }
    popModal();
  };

  const handleColorChange = (e) => {
    setSelectedColor(bgColorById[e.target.id]);
  };

  return (
    <div className="ly_common ly_wallpaper">
      <h3 className="title">{t('talk_main_background')}</h3>
      <p className="desc">{t('talk_main_background_popup')}</p>
      <div className="layer_contents">
        <ul className="wallpaper_list">
          {Object.keys(bgColorById).map((key) => (
            <li className="item" key={key}>
              <input
                type="radio"
                id={key}
                name="wallpaper"
                onChange={handleColorChange}
                checked={selectedColor === bgColorById[key]}
              />
              <label htmlFor={key} className={key}></label>
            </li>
          ))}
        </ul>
      </div>
      <div className="btn_area">
        <button type="button" className="lw_btn_40" onClick={handleClickClose}>
          {t('button_cancel')}
        </button>
        <button type="button" className="lw_btn_point_40" onClick={handleSave}>
          {t('button_save')}
        </button>
      </div>
      <button type="button" className="btn_close" onClick={handleClickClose}>
        {t('button_close')}
      </button>
    </div>
  );
}
